module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'e7m6b1su',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
